<template>
  <div class="navleft">
    <ul>
      <li
        v-for="(item, index) in xtlist"
        :key="index"
        :class="{ active: activeIndex == index }"
      >
        <div>
          <router-link :to="item.manageUrl">
            <div class="systemInfo">{{ item.menuName }}</div>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      xtlist: [
        { menuName: "用户管理", manageUrl: "/authFront/userManage" },
        { menuName: "组织机构", manageUrl: "/authFront/orgnization" },
        { menuName: "菜单管理", manageUrl: "/authFront/rolePower" },
      ],
    };
  },
  props: ["activeIndex"],
  mounted() {
    this.getSystem();
  },
  methods: {
    getSystem() {
      let self = this;
      self.$http.post(
        self.api.usersIndex,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        (res) => {
          if (res) {
            // self.xtlist = res.body.xtList;
          } else {
          }
        },
        (error) => {}
      );
    },
  },
};
</script>
<style>
.navleft {
width: 300px;
    background: #303133;
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    /* padding-top: 25px; */
    color: #FFF;
    padding-top: 64px;
}
.navleft ul li {
  line-height: 52px;
  width: 100%;
  margin: 0 auto;
  text-indent: 60px;
  color:#fff
}
.navleft ul li.active {
  background: #f7f7f7;
}
.navleft ul li.active div {
  color: #409eff;
}
.navleft ul li a {
  text-decoration: none;
}
.navleft ul li a div {
  color: #FFF;
  font-family: emoji;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/navLeft.vue